import { render } from "./WalletButton.vue?vue&type=template&id=140ea55a&ts=true"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=140ea55a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__